import { Avatar, Box, Button, Card, Typography, useTheme } from '@mui/material'
import StudyMaterialDetails from '../../components/audit/facultypage/StudyMaterialDetails'
import AssignmentDetails from '../../components/audit/facultypage/AssignmentDetails'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ExamDetails from '../../components/audit/facultypage/ExamDetails'
import React, { useCallback, useEffect, useState } from 'react'
import { Icons } from '../../utils/utilities'
import api from '../../service/api'
import QuizDetails from '../../components/audit/facultypage/QuizDetails'
import QuestionBankDetails from '../../components/audit/facultypage/QuestionBankDetails'
import DiscussionDetails from '../../components/audit/facultypage/DiscussionDetails'
import axios from 'axios'
import CustomChip from '../../components/common/CustomChip'

const FacultyAudit = () => {

    const { empcode } = useParams()

    const [profileImage, setProfileImage] = useState( null )
    const [userData, setUserData] = useState( null )
    const [loading, setLoading] = useState( true )
    const [error, setError] = useState( null )

    const { layout, palette, border } = useTheme()

    const navigate = useNavigate()
    const [searchParams] = useSearchParams( { redirect: "", legacy: false } )
    const legacy = searchParams.get( 'legacy' ) === 'true'

    const navigateBack = () => {
        const redirectPath = searchParams.get( 'redirect' )
        navigate( redirectPath || -1 )
    }

    const getUserProfileImage = async ( userData ) => {
        try {
            const { data } = await axios( `https://acerp.acharyaerptech.in/api/employee/employeeDetailsFileDownload?fileName=${userData.image_path}`, { responseType: "blob" } )
            const url = URL.createObjectURL( data )
            setProfileImage( url )
            console.log( url )


        } catch ( err ) {

        }
    }

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: { userData } } = await api.audit.fetchUserDetails( empcode, { legacy } )
            if ( userData.image_path ) {
                getUserProfileImage( userData )
            }
            setError( null )
            setUserData( userData )
        } catch ( err ) {
            setError( err?.response?.data?.message || "Something went wrong while fetching user details." )
        } finally {
            setLoading( false )
        }
    }, [empcode, legacy] )

    useEffect( () => {
        getData()
    }, [getData] )


    return (
        !error ? <Box display="flex" flexGrow={1} flexDirection="column" gap="20px" padding="20px" overflow="auto">

            <Button onClick={navigateBack} size="small" sx={{ width: "fit-content", color: "GrayText" }} startIcon={Icons.default.ArrowBack}>
                <Typography color="GrayText" textTransform="capitalize" variant='subtitle2'>Back</Typography>
            </Button>

            <Card sx={{ flexShrink: "0", width: "100%" }}>
                {!loading && userData && <Box padding="10px" gap="10px" justifyContent="space-between" display="flex">
                    <Box display="flex" alignItems="center" gap="10px">
                        {profileImage && <Box width="45px" height="45px">
                            <Box height="100%" width="100%" borderRadius={layout.borderRadius} sx={{ objectFit: "cover" }} component="img" loading='lazy' src={profileImage} alt={userData.username} />
                        </Box>}
                        {!profileImage && <Avatar sx={{ aspectRatio: 1, width: "70px", height: "70px", borderRadius: "10px", objectFit: "cover" }} />}
                        <Box display="flex" flexDirection="column" justifyContent="center">
                            <Typography gutterBottom variant='h6' fontSize="16px" textTransform="capitalize" color="primaryDark.main" >{userData.employee_name?.toLowerCase()}</Typography>
                            <Box color={palette.text.secondary} display="flex" gap="5px" fontSize="14px" alignItems="center">
                                <CustomChip tooltipTitle='Institute' value={userData.institute_name_short} />
                                <CustomChip tooltipTitle='Department' textStyles={{ textTransform: "capitalize" }} value={userData.branch_name?.toLowerCase()} />
                            </Box>
                        </Box>
                    </Box>
                </Box>}
            </Card>

            <Box>
                {!loading && <Box flexDirection="column" display="flex" gap={layout.sectionsGap} width="100%">
                    {/* ASSIGNMENTS DETAILS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Assignments</Typography>
                        {userData && <AssignmentDetails userData={userData} />}
                    </Box>

                    {/* EXAMS DETAILS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Exams</Typography>
                        {userData && <ExamDetails userData={userData} />}
                    </Box>

                    {/* MATERIALS DETAILS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Study Materials</Typography>
                        {userData && <StudyMaterialDetails userData={userData} />}
                    </Box>

                    {/* QUIZZES DETAILS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Quizzes</Typography>
                        {userData && <QuizDetails userData={userData} />}
                    </Box>

                    {/* QUESTION BANKS DETAILS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Question banks</Typography>
                        {userData && <QuestionBankDetails userData={userData} />}
                    </Box>

                    {/* DISCUSSIONS */}
                    <Box>
                        <Typography variant="h1" fontWeight="500" gutterBottom component="h2" fontSize="16px">Discussions</Typography>
                        {userData && <DiscussionDetails userData={userData} />}
                    </Box>
                </Box>}
                {loading && <DataLoadingSpinner waitingMessage="Loading assignments please wait..." />}
            </Box>
        </Box > : <Box display="flex" flexGrow={1} justifyContent="center">
            <TryAgainMessageBlock imageHeight='200px' err={error} loading={loading} getData={getData} />
        </Box>
    )
}

export default FacultyAudit
